const purchase = {
  title: "HitPaw Çevrimiçi Pro",
  subTitle: "Basit ve şeffaf fiyatlandırma ile doğru planı seçin",
  monthlyUppercase: "AYLIK",
  montly: "Aylık",
  free: "ÜCRETSİZ",
  yearlyUppercase: "YILLIK",
  yearly: "Yıllık",
  inService: "Hizmette",
  buyBtn: "Şimdi Satın Al",
  freeTips1: "Maksimum 20 MB dosya boyutunu destekler",
  freeTips2: "günde 6 dosya",
  freeTips3: "Normal işlem hızı",
  freeTips4: "Normal indirme hızı",
  freeTips5: "Günde 1 fotoğraftan arka planı kaldır",
  freeTips6: "Tüm ücretsiz araçlara erişim",
  vipTips1: "Sınırsız dosya boyutu",
  vipTips2: "Günde sınırsız dosya",
  vipTips3: "10 kat daha hızlı indirme hızı",
  vipTips4: "10 kat daha hızlı işlem hızı",
  vipTips5: "Sınırsız",
  vipTips6: "Günlük sınırsız görüntü arka planı kaldırma",
  vipTips7: "Tüm araçlara ve premium özelliklere erişim",
  vipTips8: "Otomatik olarak yenileyin ve istediğiniz zaman iptal edin.",
  vipTips9: "Video boyutu ve miktar sınırı yok",
  vipTips10: "Sınırsız resim arka planlarını kaldırın",
  vipTips11: "10 kat daha hızlı video işleme ve indirme hızı",
  vipTips12: "Tüm ücretsiz araçlara ve premium özelliklere erişim",
  acceptTitle: "Kabul Ediyoruz",
  modalTitle: "Tüm premium özelliklere erişmek için Pro'ya yükseltin",
  total: "Toplam",
  enterCode: "Kodu girin",
  SignUpToPurchaseBtn: "Satın Almak için Kaydolun",
  purchaseBtn: "Satın Almaya Git",
  saveTips: "% {{num}}' ye Kadar Tasarruf Edin",
  discount: "İndirim",
  purchaseTips: "Otomatik olarak yenileyin ve istediğiniz zaman iptal edin.",
  tips: "İpuçları:",
  promoCodeInvalidTips: "Promosyon kodunuz geçersiz",
};

export default purchase;
